import React from 'react';
import { styled } from '@compiled/react';
import Spinner from '@atlaskit/spinner/spinner';
import { lazyForPaint, type LazyComponent } from '@atlassian/react-loosely-lazy';
import type CsatSettingsPageType from './CsatSettingApp.tsx';
import type { CsatSettingsProps } from './CsatSettingApp.tsx';

export const LoadingComponent = (): React.JSX.Element => (
	<SpinnerContainer>
		<Spinner size="large" />
	</SpinnerContainer>
);

export const LazyCsatSettingsPage: LazyComponent<
	({ initialState }: CsatSettingsProps) => React.JSX.Element
> = lazyForPaint<typeof CsatSettingsPageType>(
	() => import(/* webpackChunkName: "async-csat-settings-page" */ './CsatSettingApp.tsx'),
);

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const SpinnerContainer = styled.div({
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'center',
	height: '120px',
});
